<template>
  <v-app>
    <component :is="layout">
      <transition name="slide" mode="out-in">
        <router-view/>
      </transition>
    </component>
  </v-app>
</template>

<script>
const default_layout = 'default'
export default {
  name: 'App',
  data () {
    return {
      //
    }
  },
  computed: {
    layout() {
      return this.$route.meta.layout+ '-layout'
    }
  }
}
</script>

<style lang="scss">
  @font-face {
    font-family: "GT-Walsheim-Pro-Regular";
    src: url("./assets/fonts/GT-Walsheim-Pro-Regular.ttf");
  }
  @import "./assets/sass/variables";
  @import "./assets/sass/buttons";
  @import "./assets/sass/cards";
  @import "./assets/sass/inputs";
  @import "./assets/sass/text";
  @import "./assets/sass/layout";
  @import "./assets/sass/commponents/header-toolbar";
  @import "./assets/sass/commponents/sidebar";
  @import "./assets/sass/commponents/rules";
  @import "./assets/sass/commponents/blocks-build";
  @import "./assets/sass/commponents/blocks";
  @import "./assets/sass/commponents/add.block.buttons";
  @import "./assets/sass/commponents/image-uploader";
  @import "./assets/sass/commponents/login";
  @import "./assets/sass/commponents/chat-preview";
  .slide-enter-active{
    animation: slide-in 500ms ease-out forwards;
  }

  .slide-leave-active{
    animation: slide-out 500ms ease-out forwards;
  }
  @keyframes slide-in {
    from{
      transform: translateY(-30px);
      opacity:0;
    }
    to{
      transform: translateY(0);
      opacity: 1;
    }
  }

  @keyframes slide-out {
    from{
      transform: translateY(0);
      opacity:1;
    }
    to{
      transform: translateY(-30px);
      opacity: 0;
    }
  }
</style>